export default __webpack_public_path__ + "static/media/back.25f37cd9.jpeg";